export const enum BMotionType {
    TRANS = 0, //Translation or Move
    SCALE, // Scaling
    ROTA, //Rotation
    FADE, //Opacity
    LIBM, //Linear BMotion
    CUBM, //Curvilinear BMotion
    LIPATH, //Linear Path
    CUPATH, //Curvilinear Path
    REVO, //Revolution
    SWING //Swing
}

export module BMotionEnums{

export function getBMotionName(type : BMotionType) : string{
    switch(type){
        case BMotionType.LIBM:
            return "Linear motion";
        case BMotionType.CUBM:
            return "Curvilinear motion";
        case BMotionType.LIPATH:
            return "Linear path";
        case BMotionType.CUPATH:
            return "Curvilinear path";
        case BMotionType.ROTA:
            return "Rotation";
        case BMotionType.REVO:
            return "Revolution";
        case BMotionType.SWING:
            return "Pendulum motion";
        case BMotionType.SCALE:
            return "Scaling";
        case BMotionType.FADE:
            return "Alpha";
        case BMotionType.TRANS:
            return "Position";
        default:
            return "Undefined";
        }
    }

}